// extracted by mini-css-extract-plugin
export default {"svgIcon":"Z0g3x","large":"qbowr"};